/* ═══════════════════════════════════════════════════════
   INNOVA 3996 — section behaviour

   Progressive enhancement: the page is fully readable with
   this file blocked. Everything is queried inside the
   .iv3996 wrapper so multiple sections (or a theme editor
   re-render) can never cross-wire.
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.ivReady === '1') return;
    root.dataset.ivReady = '1';

    var $ = function (sel) { return root.querySelectorAll(sel); };
    var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

    /* ── scroll reveal ──────────────────────────────── */
    var revealables = $('.iv-rv');

    if (!('IntersectionObserver' in window)) {
      each(revealables, function (el) { el.classList.add('iv-in'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('iv-in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      each(revealables, function (el, i) {
        // Stagger siblings for a softer cascade.
        el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
        revealObserver.observe(el);
      });
    }

    /* ── animated counters ──────────────────────────── */
    function easeOutExpo(t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }

    function runCount(el) {
      var target = parseFloat(el.dataset.count);
      var decimals = parseInt(el.dataset.decimals || '0', 10);
      if (isNaN(target)) return;

      if (reduced) { el.textContent = target.toFixed(decimals); return; }

      var duration = 1500;
      var start = null;

      function step(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / duration, 1);
        el.textContent = (target * easeOutExpo(t)).toFixed(decimals);
        if (t < 1) window.requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals);
      }
      window.requestAnimationFrame(step);
    }

    var counters = $('.iv-num[data-count]');

    if (!('IntersectionObserver' in window)) {
      each(counters, runCount);
    } else {
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runCount(entry.target);
          countObserver.unobserve(entry.target);
        });
      }, { threshold: 0.6 });

      each(counters, function (el) { countObserver.observe(el); });
    }

    /* ── anatomy hotspots ───────────────────────────── */
    var hotspots = $('.iv-hotspot');
    var zones = $('.iv-zone');

    function selectZone(name) {
      each(hotspots, function (h) {
        var on = h.dataset.zone === name;
        h.classList.toggle('iv-is-active', on);
        h.setAttribute('aria-pressed', String(on));
      });
      each(zones, function (z) {
        var on = z.dataset.zone === name;
        z.classList.toggle('iv-is-active', on);
        z.setAttribute('aria-expanded', String(on));
      });
    }

    each(hotspots, function (h) {
      h.setAttribute('aria-pressed', 'false');
      h.addEventListener('click', function () { selectZone(h.dataset.zone); });
      h.addEventListener('mouseenter', function () { selectZone(h.dataset.zone); });
    });

    each(zones, function (z) {
      z.setAttribute('aria-expanded', String(z.classList.contains('iv-is-active')));
      z.addEventListener('click', function () { selectZone(z.dataset.zone); });
      z.addEventListener('mouseenter', function () { selectZone(z.dataset.zone); });
    });

    if (hotspots.length) selectZone(hotspots[0].dataset.zone);

    /* ── FAQ: one answer open at a time ─────────────── */
    var faqItems = $('.iv-faq details');
    each(faqItems, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        each(faqItems, function (other) { if (other !== item) other.open = false; });
      });
    });

    /* ════════════════════════════════════════════════════
       CART

       This page carries its own slide-in drawer rather than
       handing off to the theme's. It is driven by the real
       /cart.js, so everything in it is live.
       ════════════════════════════════════════════════════ */
    var drawer = root.querySelector('[data-iv-cart]');

    if (drawer) {
      // position: fixed breaks inside a transformed or clipping ancestor, and a
      // theme wrapper may well be one. Hoisting to <body> settles it. Drop any
      // copy a previous render of this section left behind.
      each(document.querySelectorAll('body > [data-iv-cart]'), function (stale) {
        if (stale !== drawer) stale.parentNode.removeChild(stale);
      });
      document.body.appendChild(drawer);
      // Shipped hidden so it can never flash before this file takes over.
      drawer.removeAttribute('hidden');
    }

    var panel      = drawer && drawer.querySelector('[data-iv-cart-panel]');
    var itemsEl    = drawer && drawer.querySelector('[data-iv-cart-items]');
    var countEl    = drawer && drawer.querySelector('[data-iv-cart-count]');
    var flashEl    = drawer && drawer.querySelector('[data-iv-cart-flash]');
    var subtotalEl = drawer && drawer.querySelector('[data-iv-cart-subtotal]');
    var totalEl    = drawer && drawer.querySelector('[data-iv-cart-total]');
    var discEl     = drawer && drawer.querySelector('[data-iv-cart-disc]');
    var discValEl  = drawer && drawer.querySelector('[data-iv-cart-disc-val]');

    /* ── money ──────────────────────────────────────────
       Shopify hands prices to /cart.js as integer cents, so formatting is on
       us. The section passes the shop's own money_format through; the Intl
       fallback is only for the local preview. */
    var money = (function (fmt) {
      fmt = (fmt || '').replace(/<[^>]*>/g, '');   // money_format may carry markup
      var token = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);

      function group(digits, sep) {
        return digits.replace(/(\d)(?=(\d{3})+$)/g, '$1' + sep);
      }

      if (!token) {
        var currency = (window.Shopify && window.Shopify.currency &&
                        window.Shopify.currency.active) || 'USD';
        return function (cents) {
          try {
            return new Intl.NumberFormat(undefined, {
              style: 'currency', currency: currency
            }).format(cents / 100);
          } catch (e) {
            return '$' + (cents / 100).toFixed(2);
          }
        };
      }

      return function (cents) {
        var fixed = (Math.abs(cents) / 100).toFixed(2).split('.');
        var value;
        switch (token[1]) {
          case 'amount_no_decimals':
            value = group(String(Math.round(Math.abs(cents) / 100)), ','); break;
          case 'amount_with_comma_separator':
            value = group(fixed[0], '.') + ',' + fixed[1]; break;
          case 'amount_no_decimals_with_comma_separator':
            value = group(String(Math.round(Math.abs(cents) / 100)), '.'); break;
          case 'amount_with_apostrophe_separator':
            value = group(fixed[0], "'") + '.' + fixed[1]; break;
          default:
            value = group(fixed[0], ',') + '.' + fixed[1];
        }
        return (cents < 0 ? '-' : '') + fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    })(drawer ? drawer.dataset.ivMoneyFormat : '');

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    }

    /* ── render ─────────────────────────────────────── */
    function renderCart(cart) {
      if (!drawer) return;

      if (countEl) {
        countEl.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
      }

      itemsEl.textContent = '';

      if (!cart.items || !cart.items.length) {
        itemsEl.appendChild(el('p', 'iv-cart-empty', 'Your cart is empty'));
      } else {
        cart.items.forEach(function (item, i) {
          var row = el('div', 'iv-citem');
          row.dataset.line = String(i + 1);

          var src = (item.featured_image && item.featured_image.url) || item.image;
          if (src) {
            var figure = el('div', 'iv-ci-img');
            var img = el('img');
            // Shopify CDN urls always carry a query already (?v=…).
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=104';
            img.width = 52;
            img.height = 52;
            img.loading = 'lazy';
            img.alt = (item.featured_image && item.featured_image.alt) || '';
            figure.appendChild(img);
            row.appendChild(figure);
          }

          var info = el('div', 'iv-ci-info');
          var name = el('a', 'iv-ci-name', item.product_title || item.title);
          name.href = item.url || '#';
          info.appendChild(name);

          var sub = el('div', 'iv-ci-sub');
          var bits = [];
          if (item.variant_title && item.variant_title !== 'Default Title') {
            bits.push(item.variant_title);
          }
          bits.push('Qty ' + item.quantity);
          sub.appendChild(el('span', null, bits.join(' · ')));

          var remove = el('button', 'iv-ci-x', 'Remove');
          remove.type = 'button';
          remove.dataset.ivCartRemove = String(i + 1);
          remove.setAttribute('aria-label', 'Remove ' + (item.product_title || item.title) + ' from cart');
          sub.appendChild(remove);
          info.appendChild(sub);
          row.appendChild(info);

          var price = el('div', 'iv-ci-price');
          if (item.original_line_price > item.final_line_price) {
            price.appendChild(el('s', null, money(item.original_line_price)));
          }
          price.appendChild(el('b', item.final_line_price === 0 ? 'iv-free' : null,
                               item.final_line_price === 0 ? 'Free' : money(item.final_line_price)));
          row.appendChild(price);

          itemsEl.appendChild(row);
        });
      }

      if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price);
      if (totalEl) totalEl.textContent = money(cart.total_price);

      if (discEl) {
        var discount = cart.total_discount || 0;
        discEl.hidden = discount <= 0;
        if (discValEl && discount > 0) discValEl.textContent = '−' + money(discount);
      }
    }

    function fetchCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      }).then(readJSON);
    }

    /* A proxy, CDN or redirect can answer with HTML; never let a JSON parse
       error surface as the shopper-facing message. */
    function readJSON(res) {
      return res.text().then(function (text) {
        var body = null;
        try { body = JSON.parse(text); } catch (parseError) { body = null; }
        if (!res.ok) {
          throw new Error((body && (body.description || body.message)) ||
                          'Sorry — we could not update your cart. Please try again.');
        }
        if (!body) throw new Error('Sorry — we could not update your cart. Please try again.');
        return body;
      });
    }

    /* ── open / close ───────────────────────────────── */
    var lastFocus = null;

    function openCart() {
      if (!drawer || drawer.classList.contains('iv-is-open')) return;
      lastFocus = document.activeElement;
      drawer.classList.add('iv-is-open');
      document.documentElement.classList.add('iv-cart-lock');
      // Two steps so the panel transitions in from its off-screen position
      // instead of appearing already open. Both timers call this; whichever
      // lands first wins, and a second call changes nothing.
      function reveal() {
        if (!drawer.classList.contains('iv-is-open')) return;
        drawer.classList.add('iv-is-shown');
        if (panel && document.activeElement !== panel) panel.focus();
      }
      window.requestAnimationFrame(reveal);
      // rAF is parked in a hidden or non-compositing tab. Without this the
      // drawer would be open but blank until the tab came back into view.
      window.setTimeout(reveal, 60);
    }

    function closeCart() {
      if (!drawer || !drawer.classList.contains('iv-is-open')) return;
      drawer.classList.remove('iv-is-shown');
      document.documentElement.classList.remove('iv-cart-lock');
      if (flashEl) flashEl.hidden = true;
      window.setTimeout(function () {
        drawer.classList.remove('iv-is-open');
      }, reduced ? 0 : 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    if (drawer) {
      each(drawer.querySelectorAll('[data-iv-cart-close]'), function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) return;
        if (drawer.classList.contains('iv-is-open')) closeCart();
      });

      // Keep tabbing inside the panel while it is open.
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var focusable = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });

      /* ── remove a line ───────────────────────────── */
      itemsEl.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-iv-cart-remove]') : null;
        if (!btn) return;
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        btn.textContent = 'Removing…';

        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(btn.dataset.ivCartRemove), quantity: 0 })
        })
          .then(readJSON)
          .then(function (cart) {
            renderCart(cart);
            notifyTheme(cart);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Remove';
          });
      });
    }

    /* ── tell the theme, without opening its drawer ─────
       The store's header count, cart bubble and cart page all refresh off
       Horizon's "cart:update" event, so we still fire it. Its cart-items
       component reads event.detail.data.sections?.[id] — leaving `sections`
       out makes it re-render from the server, which is what we want.

       The stock drawer listens to the same event and would slide itself open
       on top of ours, so its open methods are stubbed for the moment it takes
       to react, then handed straight back. */
    function notifyTheme(resource) {
      var stock = document.querySelector('cart-drawer-component, cart-drawer');
      var dialog = stock && stock.querySelector('dialog');
      var patched = [];

      function silence(obj, key) {
        if (!obj || typeof obj[key] !== 'function') return;
        obj[key] = function () {};
        patched.push([obj, key]);
      }

      silence(stock, 'showDialog');
      silence(dialog, 'showModal');
      silence(dialog, 'show');

      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: resource, sourceId: 'iv3996', data: {} }
        }));
      } finally {
        // Long enough to cover the theme's own async re-render.
        window.setTimeout(function () {
          patched.forEach(function (pair) {
            // These are own properties shadowing prototype methods; deleting
            // restores the real ones.
            try { delete pair[0][pair[1]]; } catch (e) { /* leave the stub */ }
          });
        }, 1200);
      }
    }

    /* ── add to cart ────────────────────────────────────
       Both the hero and the buy card carry a real form posting to /cart/add,
       so the page still sells with JS blocked. Here we upgrade it: add over
       fetch, then open our own drawer. */
    each($('[data-iv-add]'), function (addForm) {
      if (!window.fetch) return;

      addForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = addForm.querySelector('[data-iv-add-btn]');
        var label = addForm.querySelector('[data-iv-add-label]');
        var errorEl = addForm.querySelector('[data-iv-add-error]');
        var variant = addForm.querySelector('input[name="id"]').value;
        var original = label ? label.textContent : '';

        if (btn.disabled) return;
        btn.disabled = true;
        if (label) label.textContent = 'Adding…';
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        function restore() {
          if (label) label.textContent = original;
          btn.disabled = false;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
        })
          .then(readJSON)
          .then(function (added) {
            notifyTheme(added);

            // No drawer in the markup? Fall back to the cart page.
            if (!drawer) { window.location.href = '/cart'; return; }

            if (label) label.textContent = 'Added';
            window.setTimeout(restore, 1600);

            return fetchCart().then(function (cart) {
              if (flashEl) flashEl.hidden = false;
              renderCart(cart);
              openCart();
            });
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
            restore();
          });
      });
    });

    /* ── montage: decorative, so freeze it when motion is unwelcome ── */
    var montage = root.querySelector('.iv-montage');
    if (montage) {
      if (reduced) {
        montage.removeAttribute('autoplay');
        montage.pause();
      } else if (montage.paused) {
        // Some browsers refuse the autoplay attribute but allow a muted play().
        var p = montage.play();
        if (p && p.catch) p.catch(function () { /* poster stands in */ });
      }
    }

    /* ── hero parallax on the product shot ──────────── */
    var shot = root.querySelector('.iv-hero-shot img');
    var hero = root.querySelector('.iv-hero');
    if (shot && hero && !reduced && window.matchMedia('(min-width: 1081px)').matches) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - 0.5;
        var dy = (e.clientY - r.top) / r.height - 0.5;
        shot.style.transform = 'translate3d(' + (dx * -14).toFixed(2) + 'px,' +
                               (dy * -10).toFixed(2) + 'px,0)';
      });
      hero.addEventListener('pointerleave', function () { shot.style.transform = ''; });
      shot.style.transition = 'transform .6s cubic-bezier(.22,.61,.36,1)';
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.iv3996'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor re-renders sections in place — re-init on load. */
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.iv3996'), init);
  });
})();
